module.exports = __webpack_public_path__ + "img/invitation-icon.7ebd56bb.png";